'use strict';

function isRealNaN(obj) {
  // This is only true of NaN
  return obj != null && obj !== obj;
}

module.exports = isRealNaN;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/internal/isRealNaN.js
// module id = 730
// module chunks = 0